<mat-card>
    <mat-icon *ngIf="!isSVG">{{iconName}}</mat-icon>
    <mat-icon *ngIf="isSVG" [svgIcon]="iconName" color="primary"></mat-icon>
    <mat-card-actions>
        <button [color]="'primary'" mat-raised-button>{{label}}
        </button>
    </mat-card-actions>
</mat-card>
